import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Tooltip from 'components/tooltip';
import TableCellLegendOverlay from 'components/table_cell_legend_overlay';

// Usage:
//   By default:
//     Renders children in a one-line TD with ellipses on overflow and a tooltip on hover
//   With a tooltip prop:
//     Uses the tooltip prop for the tooltip content instead of children
//   With the input prop:
//     Renders children as-is (meant for rendering inputs, unsurprisingly)
//   With the input prop and readOnly:
//     Renders as if input were false, using the tooltip prop as children
//     i.e. The tooltip prop is actually both the tooltip and the read only value
export default function VoucherEditorTableTD({
  children,
  className,
  input,
  legendColor,
  numeric,
  readOnly,
  sticky,
  tooltip,
  ...props
}) {
  let content;
  if ((input && !readOnly) || tooltip === false) {
    content = children;
  } else {
    const ref = React.createRef();
    content = (
      <Tooltip
        childrenRef={ref}
        content={tooltip == null ? children : tooltip}
        onlyOnOverflow
        placement="bottom"
      >
        <span ref={ref}>{input ? tooltip : children}</span>
      </Tooltip>
    );
  }

  return (
    <td
      className={classNames(className, {
        numeric,
        'position-relative': legendColor,
        'end-cell sticky-cell': sticky,
      })}
      {...props}
    >
      {content}
      {legendColor && <TableCellLegendOverlay color={legendColor} />}
    </td>
  );
}

VoucherEditorTableTD.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  input: PropTypes.bool,
  legendColor: PropTypes.string,
  numeric: PropTypes.bool,
  readOnly: PropTypes.bool,
  sticky: PropTypes.bool,
  tooltip: PropTypes.node,
};
